import React from "react";

const Images = ({ img }) => {
    return <div className="header__wrapper__img"></div>;
};

export default Images;
